function getConfig(name, defaultValue = null) {
    // If inside a docker container, use window.ENV
    if (window.ENV !== undefined) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

export function getBackendUrl() {
    const url = getConfig('REACT_APP_BACKEND_URL');
    if (url) return url;
    if (typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost') {
        return 'http://localhost:8080';
    }
    return '';
}

export function getHoursCloseTicketsAuto() {
    return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}

export function getFrontendPort() {
    return getConfig('SERVER_PORT');
}

export function getPrimaryColor() {
    return getConfig("REACT_APP_PRIMARY_COLOR");
}

export function getPrimaryDark() {
    return getConfig("REACT_APP_PRIMARY_DARK");
}

export function getNumberSupport() {
    return getConfig("REACT_APP_NUMBER_SUPPORT");
}

export function getEnvToken() {
    return getConfig("REACT_APP_ENV_TOKEN") || getConfig("ENV_TOKEN");
}